// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"214":"3caf2537","732":"ed1fc981"}[chunkId] + ".chunk.css";
};